var graphql_schema_ApprovalRequirementEnum = /*#__PURE__*/ function(ApprovalRequirementEnum) {
    ApprovalRequirementEnum["FINAL_PROJECT"] = "FINAL_PROJECT";
    ApprovalRequirementEnum["NOT_REQUIREMENT"] = "NOT_REQUIREMENT";
    ApprovalRequirementEnum["QUIZ_EVALUATION"] = "QUIZ_EVALUATION";
    return ApprovalRequirementEnum;
}({});
var graphql_schema_BannerIdentifier = /*#__PURE__*/ function(BannerIdentifier) {
    BannerIdentifier["ALL_MEMBERSHIPS"] = "ALL_MEMBERSHIPS";
    BannerIdentifier["CATALOG_CAMPAIGN"] = "CATALOG_CAMPAIGN";
    BannerIdentifier["EXPIRE_MEMBERSHIP"] = "EXPIRE_MEMBERSHIP";
    BannerIdentifier["MEMBERSHIP_CAMPAIGN"] = "MEMBERSHIP_CAMPAIGN";
    BannerIdentifier["MEMBERSHIP_LANDING"] = "MEMBERSHIP_LANDING";
    BannerIdentifier["NEW_USER"] = "NEW_USER";
    BannerIdentifier["REFER_FRIEND"] = "REFER_FRIEND";
    BannerIdentifier["REMINDER_SUBSCRIPTION"] = "REMINDER_SUBSCRIPTION";
    BannerIdentifier["RENOVATE_MEMBERSHIP"] = "RENOVATE_MEMBERSHIP";
    BannerIdentifier["SHOPPING_CART"] = "SHOPPING_CART";
    return BannerIdentifier;
}({});
var graphql_schema_BannerLandingEnum = /*#__PURE__*/ function(BannerLandingEnum) {
    BannerLandingEnum["CAMPAIGN_LANDING"] = "CAMPAIGN_LANDING";
    BannerLandingEnum["DEGREE_LANDING"] = "DEGREE_LANDING";
    BannerLandingEnum["MEMBERSHIP_LANDING"] = "MEMBERSHIP_LANDING";
    return BannerLandingEnum;
}({});
var graphql_schema_CanAnswerReason = /*#__PURE__*/ function(CanAnswerReason) {
    CanAnswerReason["SURVEY_CLOSED"] = "SURVEY_CLOSED";
    CanAnswerReason["SURVEY_COMPLETED"] = "SURVEY_COMPLETED";
    CanAnswerReason["SURVEY_EXPIRED"] = "SURVEY_EXPIRED";
    return CanAnswerReason;
}({});
var graphql_schema_CertificateTypeEnum = /*#__PURE__*/ function(CertificateTypeEnum) {
    CertificateTypeEnum["ACADEMY_SKILL_PATH"] = "ACADEMY_SKILL_PATH";
    CertificateTypeEnum["B2B_TRACK"] = "B2B_TRACK";
    CertificateTypeEnum["CAREER"] = "CAREER";
    CertificateTypeEnum["CERTIFICATION"] = "CERTIFICATION";
    CertificateTypeEnum["COURSE"] = "COURSE";
    return CertificateTypeEnum;
}({});
var graphql_schema_ContactSourceEnum = /*#__PURE__*/ function(ContactSourceEnum) {
    ContactSourceEnum["SOURCE_B2B_LANDING_MENU_MOBILE"] = "SOURCE_B2B_LANDING_MENU_MOBILE";
    ContactSourceEnum["SOURCE_B2B_LAST_SECTION"] = "SOURCE_B2B_LAST_SECTION";
    ContactSourceEnum["SOURCE_BLOG_ARTICLE_DETAIL"] = "SOURCE_BLOG_ARTICLE_DETAIL";
    ContactSourceEnum["SOURCE_BLOG_BANNER"] = "SOURCE_BLOG_BANNER";
    ContactSourceEnum["SOURCE_BLOG_CATEGORIES"] = "SOURCE_BLOG_CATEGORIES";
    ContactSourceEnum["SOURCE_BLOG_DETAIL"] = "SOURCE_BLOG_DETAIL";
    ContactSourceEnum["SOURCE_BLOG_HOME"] = "SOURCE_BLOG_HOME";
    ContactSourceEnum["SOURCE_CALL_CENTER_CATALOG_POPUP"] = "SOURCE_CALL_CENTER_CATALOG_POPUP";
    ContactSourceEnum["SOURCE_CALL_CENTER_DIALOG_BLOG"] = "SOURCE_CALL_CENTER_DIALOG_BLOG";
    ContactSourceEnum["SOURCE_CALL_CENTER_DIALOG_BLOG_DETAIL"] = "SOURCE_CALL_CENTER_DIALOG_BLOG_DETAIL";
    ContactSourceEnum["SOURCE_CALL_CENTER_DIALOG_HOME"] = "SOURCE_CALL_CENTER_DIALOG_HOME";
    ContactSourceEnum["SOURCE_CALL_CENTER_HOME_CTA_BUTTON"] = "SOURCE_CALL_CENTER_HOME_CTA_BUTTON";
    ContactSourceEnum["SOURCE_CAMPAIGN_LANDING_MENU"] = "SOURCE_CAMPAIGN_LANDING_MENU";
    ContactSourceEnum["SOURCE_CHECKOUT"] = "SOURCE_CHECKOUT";
    ContactSourceEnum["SOURCE_CLASSROOM"] = "SOURCE_CLASSROOM";
    ContactSourceEnum["SOURCE_COUPON_PREMIUM"] = "SOURCE_COUPON_PREMIUM";
    ContactSourceEnum["SOURCE_COURSE_DETAIL_MEMBERSHIP_POPUP"] = "SOURCE_COURSE_DETAIL_MEMBERSHIP_POPUP";
    ContactSourceEnum["SOURCE_COURSE_FREE_LANDING"] = "SOURCE_COURSE_FREE_LANDING";
    ContactSourceEnum["SOURCE_COURSE_FREE_OF_THE_DAY"] = "SOURCE_COURSE_FREE_OF_THE_DAY";
    ContactSourceEnum["SOURCE_COURSE_OPTION"] = "SOURCE_COURSE_OPTION";
    ContactSourceEnum["SOURCE_DEGREE"] = "SOURCE_DEGREE";
    ContactSourceEnum["SOURCE_DOWNLOAD_FREE_RESOURCE"] = "SOURCE_DOWNLOAD_FREE_RESOURCE";
    ContactSourceEnum["SOURCE_HOME_HERO"] = "SOURCE_HOME_HERO";
    ContactSourceEnum["SOURCE_HOME_PHONE_NUMBER"] = "SOURCE_HOME_PHONE_NUMBER";
    ContactSourceEnum["SOURCE_HOME_POP_UP"] = "SOURCE_HOME_POP_UP";
    ContactSourceEnum["SOURCE_HOME_TOP_BANNER"] = "SOURCE_HOME_TOP_BANNER";
    ContactSourceEnum["SOURCE_HOME_USER_PAYG"] = "SOURCE_HOME_USER_PAYG";
    ContactSourceEnum["SOURCE_LANDING_LIVE"] = "SOURCE_LANDING_LIVE";
    ContactSourceEnum["SOURCE_LANDING_TOOLS"] = "SOURCE_LANDING_TOOLS";
    ContactSourceEnum["SOURCE_MEMBERSHIP_CATEGORY_LANDING"] = "SOURCE_MEMBERSHIP_CATEGORY_LANDING";
    ContactSourceEnum["SOURCE_MEMBERSHIP_LANDING"] = "SOURCE_MEMBERSHIP_LANDING";
    ContactSourceEnum["SOURCE_MEMBERSHIP_LANDING_COMPONENT"] = "SOURCE_MEMBERSHIP_LANDING_COMPONENT";
    ContactSourceEnum["SOURCE_MEMBERSHIP_LANDING_MENU"] = "SOURCE_MEMBERSHIP_LANDING_MENU";
    ContactSourceEnum["SOURCE_ORGANIC"] = "SOURCE_ORGANIC";
    ContactSourceEnum["SOURCE_PRE_CHECKOUT"] = "SOURCE_PRE_CHECKOUT";
    ContactSourceEnum["SOURCE_PRE_REGISTRATION_ALL_ACCESS"] = "SOURCE_PRE_REGISTRATION_ALL_ACCESS";
    ContactSourceEnum["SOURCE_PROJECT_CREATION"] = "SOURCE_PROJECT_CREATION";
    ContactSourceEnum["SOURCE_REGISTER_FUNNEL"] = "SOURCE_REGISTER_FUNNEL";
    ContactSourceEnum["SOURCE_REMARKETING_HERO"] = "SOURCE_REMARKETING_HERO";
    ContactSourceEnum["SOURCE_ROULETTE_HOME"] = "SOURCE_ROULETTE_HOME";
    ContactSourceEnum["SOURCE_SEARCH_POP_UP"] = "SOURCE_SEARCH_POP_UP";
    ContactSourceEnum["SOURCE_SOFE"] = "SOURCE_SOFE";
    ContactSourceEnum["SOURCE_STUDENT_MEMBERSHIP_LANDING"] = "SOURCE_STUDENT_MEMBERSHIP_LANDING";
    ContactSourceEnum["SOURCE_STUDENT_PLAN"] = "SOURCE_STUDENT_PLAN";
    ContactSourceEnum["SOURCE_TEMPLATE_PAAS_MENU"] = "SOURCE_TEMPLATE_PAAS_MENU";
    ContactSourceEnum["SOURCE_TEMPORAL_ACCESS_LANDING"] = "SOURCE_TEMPORAL_ACCESS_LANDING";
    ContactSourceEnum["SOURCE_TEMPORAL_OR_FREE"] = "SOURCE_TEMPORAL_OR_FREE";
    ContactSourceEnum["SOURCE_TRACK_LANDING"] = "SOURCE_TRACK_LANDING";
    return ContactSourceEnum;
}({});
var graphql_schema_CourseTypeEnum = /*#__PURE__*/ function(CourseTypeEnum) {
    CourseTypeEnum["COURSE_TYPE_B2B"] = "COURSE_TYPE_B2B";
    CourseTypeEnum["COURSE_TYPE_B2B_CLASSROOMS"] = "COURSE_TYPE_B2B_CLASSROOMS";
    CourseTypeEnum["COURSE_TYPE_DEGREE"] = "COURSE_TYPE_DEGREE";
    CourseTypeEnum["COURSE_TYPE_FREE"] = "COURSE_TYPE_FREE";
    CourseTypeEnum["COURSE_TYPE_MEMBERSHIP"] = "COURSE_TYPE_MEMBERSHIP";
    CourseTypeEnum["COURSE_TYPE_PAID"] = "COURSE_TYPE_PAID";
    CourseTypeEnum["COURSE_TYPE_ROCKSTAR"] = "COURSE_TYPE_ROCKSTAR";
    CourseTypeEnum["COURSE_TYPE_TEMPORAL_ACCESS"] = "COURSE_TYPE_TEMPORAL_ACCESS";
    return CourseTypeEnum;
}({});
var graphql_schema_CourseVideoTrailerSourceVideoSourceType = /*#__PURE__*/ function(CourseVideoTrailerSourceVideoSourceType) {
    CourseVideoTrailerSourceVideoSourceType["HLSV3"] = "HLSV3";
    CourseVideoTrailerSourceVideoSourceType["HLSV4"] = "HLSV4";
    CourseVideoTrailerSourceVideoSourceType["MP3"] = "MP3";
    CourseVideoTrailerSourceVideoSourceType["MP4"] = "MP4";
    CourseVideoTrailerSourceVideoSourceType["NONE"] = "NONE";
    return CourseVideoTrailerSourceVideoSourceType;
}({});
var graphql_schema_DegreeLearningCourseDetailProjectTypeEnum = /*#__PURE__*/ function(DegreeLearningCourseDetailProjectTypeEnum) {
    DegreeLearningCourseDetailProjectTypeEnum["PROJECT_TYPE_OPTIONAL"] = "PROJECT_TYPE_OPTIONAL";
    DegreeLearningCourseDetailProjectTypeEnum["PROJECT_TYPE_REQUIRED"] = "PROJECT_TYPE_REQUIRED";
    return DegreeLearningCourseDetailProjectTypeEnum;
}({});
var graphql_schema_DegreeLearningEventScheduleTargetEnum = /*#__PURE__*/ function(DegreeLearningEventScheduleTargetEnum) {
    DegreeLearningEventScheduleTargetEnum["TARGET_COMPLEMENTARY_SESSION"] = "TARGET_COMPLEMENTARY_SESSION";
    DegreeLearningEventScheduleTargetEnum["TARGET_COUNSELLING"] = "TARGET_COUNSELLING";
    DegreeLearningEventScheduleTargetEnum["TARGET_KICKOFF"] = "TARGET_KICKOFF";
    return DegreeLearningEventScheduleTargetEnum;
}({});
var graphql_schema_DegreeSyllabusStatusEnum = /*#__PURE__*/ function(DegreeSyllabusStatusEnum) {
    DegreeSyllabusStatusEnum["STATUS_CLOSURE"] = "STATUS_CLOSURE";
    DegreeSyllabusStatusEnum["STATUS_FINISHED"] = "STATUS_FINISHED";
    DegreeSyllabusStatusEnum["STATUS_ONBOARDING"] = "STATUS_ONBOARDING";
    DegreeSyllabusStatusEnum["STATUS_PROGRESS"] = "STATUS_PROGRESS";
    DegreeSyllabusStatusEnum["STATUS_SALE"] = "STATUS_SALE";
    return DegreeSyllabusStatusEnum;
}({});
var graphql_schema_EnrollmentTypeEnum = /*#__PURE__*/ function(EnrollmentTypeEnum) {
    EnrollmentTypeEnum["ENROLLMENT_B2B"] = "ENROLLMENT_B2B";
    EnrollmentTypeEnum["ENROLLMENT_DEGREE"] = "ENROLLMENT_DEGREE";
    EnrollmentTypeEnum["ENROLLMENT_FREE"] = "ENROLLMENT_FREE";
    EnrollmentTypeEnum["ENROLLMENT_FREEMIUM"] = "ENROLLMENT_FREEMIUM";
    EnrollmentTypeEnum["ENROLLMENT_FREE_MEMBERSHIP"] = "ENROLLMENT_FREE_MEMBERSHIP";
    EnrollmentTypeEnum["ENROLLMENT_GITCARD"] = "ENROLLMENT_GITCARD";
    EnrollmentTypeEnum["ENROLLMENT_MEMBERSHIP"] = "ENROLLMENT_MEMBERSHIP";
    EnrollmentTypeEnum["ENROLLMENT_MENTOR"] = "ENROLLMENT_MENTOR";
    EnrollmentTypeEnum["ENROLLMENT_PAID"] = "ENROLLMENT_PAID";
    EnrollmentTypeEnum["ENROLLMENT_PREVIEW_TRIAL"] = "ENROLLMENT_PREVIEW_TRIAL";
    EnrollmentTypeEnum["ENROLLMENT_PROFESSOR"] = "ENROLLMENT_PROFESSOR";
    EnrollmentTypeEnum["ENROLLMENT_STAFF"] = "ENROLLMENT_STAFF";
    EnrollmentTypeEnum["ENROLLMENT_TEMPORAL_ACCESS"] = "ENROLLMENT_TEMPORAL_ACCESS";
    return EnrollmentTypeEnum;
}({});
var graphql_schema_LiveTargetEnum = /*#__PURE__*/ function(LiveTargetEnum) {
    LiveTargetEnum["TARGET_HIDDEN"] = "TARGET_HIDDEN";
    LiveTargetEnum["TARGET_PREMIUM"] = "TARGET_PREMIUM";
    LiveTargetEnum["TARGET_PRIVATE"] = "TARGET_PRIVATE";
    LiveTargetEnum["TARGET_PUBLIC"] = "TARGET_PUBLIC";
    return LiveTargetEnum;
}({});
var graphql_schema_MembershipTypeMethod = /*#__PURE__*/ function(MembershipTypeMethod) {
    MembershipTypeMethod["A_1"] = "A_1";
    MembershipTypeMethod["A_2"] = "A_2";
    return MembershipTypeMethod;
}({});
var graphql_schema_MembershipTypeTag = /*#__PURE__*/ function(MembershipTypeTag) {
    MembershipTypeTag["BECADO"] = "BECADO";
    MembershipTypeTag["FAMILIAR"] = "FAMILIAR";
    MembershipTypeTag["ONG_BECADO"] = "ONG_BECADO";
    MembershipTypeTag["ORGANIZATION"] = "ORGANIZATION";
    MembershipTypeTag["PLUS"] = "PLUS";
    MembershipTypeTag["PREMIUM"] = "PREMIUM";
    MembershipTypeTag["PREMIUM_DUO"] = "PREMIUM_DUO";
    MembershipTypeTag["PREMIUM_LITE"] = "PREMIUM_LITE";
    MembershipTypeTag["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
    MembershipTypeTag["PROFESIONAL"] = "PROFESIONAL";
    MembershipTypeTag["UNIVERSITY_SCHOLARSHIP"] = "UNIVERSITY_SCHOLARSHIP";
    return MembershipTypeTag;
}({});
var graphql_schema_MyUserTypeDocument = /*#__PURE__*/ function(MyUserTypeDocument) {
    MyUserTypeDocument["DNI"] = "DNI";
    MyUserTypeDocument["FOREIGNER_CARD"] = "FOREIGNER_CARD";
    MyUserTypeDocument["PASSPORT"] = "PASSPORT";
    return MyUserTypeDocument;
}({});
var graphql_schema_OnboardingEnum = /*#__PURE__*/ function(OnboardingEnum) {
    OnboardingEnum["ONBOARDING_FAMILY_PLAN"] = "ONBOARDING_FAMILY_PLAN";
    OnboardingEnum["ONBOARDING_FREEMIUM"] = "ONBOARDING_FREEMIUM";
    OnboardingEnum["ONBOARDING_FREE_MS"] = "ONBOARDING_FREE_MS";
    OnboardingEnum["ONBOARDING_MEMBERSHIP"] = "ONBOARDING_MEMBERSHIP";
    OnboardingEnum["ONBOARDING_NUMBER_FORM"] = "ONBOARDING_NUMBER_FORM";
    OnboardingEnum["ONBOARDING_PAYG"] = "ONBOARDING_PAYG";
    OnboardingEnum["ONBOARDING_SOFE"] = "ONBOARDING_SOFE";
    return OnboardingEnum;
}({});
var graphql_schema_ParticipationCertificateTypeEnum = /*#__PURE__*/ function(ParticipationCertificateTypeEnum) {
    ParticipationCertificateTypeEnum["CERTIFICATE_TYPE_COURSE"] = "CERTIFICATE_TYPE_COURSE";
    ParticipationCertificateTypeEnum["CERTIFICATE_TYPE_MINEDU"] = "CERTIFICATE_TYPE_MINEDU";
    ParticipationCertificateTypeEnum["CERTIFICATE_TYPE_SIXTH_ANNIVERSARY"] = "CERTIFICATE_TYPE_SIXTH_ANNIVERSARY";
    ParticipationCertificateTypeEnum["CERTIFICATE_TYPE_WORKSHOP"] = "CERTIFICATE_TYPE_WORKSHOP";
    return ParticipationCertificateTypeEnum;
}({});
var graphql_schema_PopupType = /*#__PURE__*/ function(PopupType) {
    PopupType["AFTER_CAMPAIGN"] = "AFTER_CAMPAIGN";
    PopupType["CALL_CENTER"] = "CALL_CENTER";
    PopupType["DURING_CAMPAIGN"] = "DURING_CAMPAIGN";
    return PopupType;
}({});
var graphql_schema_ProjectStatus = /*#__PURE__*/ function(ProjectStatus) {
    ProjectStatus["CO"] = "CO";
    ProjectStatus["IP"] = "IP";
    ProjectStatus["TI"] = "TI";
    ProjectStatus["UV"] = "UV";
    return ProjectStatus;
}({});
var graphql_schema_ProjectUploadValidationEnum = /*#__PURE__*/ function(ProjectUploadValidationEnum) {
    ProjectUploadValidationEnum["B2B_CLASSROOM_COURSE"] = "B2B_CLASSROOM_COURSE";
    ProjectUploadValidationEnum["B2B_DEMO"] = "B2B_DEMO";
    ProjectUploadValidationEnum["B2B_NO_PROJECT"] = "B2B_NO_PROJECT";
    ProjectUploadValidationEnum["TEMPORAL_ACCESS"] = "TEMPORAL_ACCESS";
    ProjectUploadValidationEnum["UNIVERSITY_SCHOLARSHIP"] = "UNIVERSITY_SCHOLARSHIP";
    return ProjectUploadValidationEnum;
}({});
var graphql_schema_PusherTargetEnum = /*#__PURE__*/ function(PusherTargetEnum) {
    PusherTargetEnum["INBOX"] = "INBOX";
    PusherTargetEnum["LIVE"] = "LIVE";
    return PusherTargetEnum;
}({});
var graphql_schema_QuestionTypeEnumField = /*#__PURE__*/ function(QuestionTypeEnumField) {
    QuestionTypeEnumField["MULTIPLE_SELECTION_CHECKBOXES_QUESTION"] = "MULTIPLE_SELECTION_CHECKBOXES_QUESTION";
    QuestionTypeEnumField["MULTIPLE_SELECTION_CHIPS_QUESTION"] = "MULTIPLE_SELECTION_CHIPS_QUESTION";
    QuestionTypeEnumField["OPEN_QUESTION"] = "OPEN_QUESTION";
    QuestionTypeEnumField["RANGE_QUESTION"] = "RANGE_QUESTION";
    QuestionTypeEnumField["SLIDER_RANGE_QUESTION"] = "SLIDER_RANGE_QUESTION";
    QuestionTypeEnumField["STARS_QUESTION"] = "STARS_QUESTION";
    QuestionTypeEnumField["UNIQUE_SELECTION_QUESTION"] = "UNIQUE_SELECTION_QUESTION";
    return QuestionTypeEnumField;
}({});
var graphql_schema_SendDiscussionValidationEnum = /*#__PURE__*/ function(SendDiscussionValidationEnum) {
    SendDiscussionValidationEnum["B2B_DEMO"] = "B2B_DEMO";
    SendDiscussionValidationEnum["TEMPORAL_ACCESS"] = "TEMPORAL_ACCESS";
    SendDiscussionValidationEnum["UNIVERSITY_SCHOLARSHIP"] = "UNIVERSITY_SCHOLARSHIP";
    return SendDiscussionValidationEnum;
}({});
var graphql_schema_SourceEnum = /*#__PURE__*/ function(SourceEnum) {
    SourceEnum["blog"] = "blog";
    SourceEnum["catalog"] = "catalog";
    SourceEnum["detail_blog"] = "detail_blog";
    SourceEnum["detail_course"] = "detail_course";
    SourceEnum["home"] = "home";
    SourceEnum["home_user"] = "home_user";
    SourceEnum["premium"] = "premium";
    return SourceEnum;
}({});
var graphql_schema_SourcesEnum = /*#__PURE__*/ function(SourcesEnum) {
    SourcesEnum["blog"] = "blog";
    SourcesEnum["catalog"] = "catalog";
    SourcesEnum["detail_blog"] = "detail_blog";
    SourcesEnum["detail_course"] = "detail_course";
    SourcesEnum["home"] = "home";
    SourcesEnum["home_user"] = "home_user";
    SourcesEnum["premium"] = "premium";
    return SourcesEnum;
}({});
var graphql_schema_StatusProjectEnum = /*#__PURE__*/ function(StatusProjectEnum) {
    StatusProjectEnum["CERTIFIED"] = "CERTIFIED";
    StatusProjectEnum["DRAFT"] = "DRAFT";
    StatusProjectEnum["FINISHED"] = "FINISHED";
    StatusProjectEnum["OBSERVED"] = "OBSERVED";
    StatusProjectEnum["PUBLISHED"] = "PUBLISHED";
    return StatusProjectEnum;
}({});
var graphql_schema_StudyPlanFrequencyEnum = /*#__PURE__*/ function(StudyPlanFrequencyEnum) {
    StudyPlanFrequencyEnum["FREQUENCY_ALL"] = "FREQUENCY_ALL";
    StudyPlanFrequencyEnum["FREQUENCY_FIVE"] = "FREQUENCY_FIVE";
    StudyPlanFrequencyEnum["FREQUENCY_ONE"] = "FREQUENCY_ONE";
    StudyPlanFrequencyEnum["FREQUENCY_THREE"] = "FREQUENCY_THREE";
    StudyPlanFrequencyEnum["FREQUENCY_TWO"] = "FREQUENCY_TWO";
    return StudyPlanFrequencyEnum;
}({});
var graphql_schema_StudyPlanTargetEnum = /*#__PURE__*/ function(StudyPlanTargetEnum) {
    StudyPlanTargetEnum["TARGET_CHILL"] = "TARGET_CHILL";
    StudyPlanTargetEnum["TARGET_INTENSIVE"] = "TARGET_INTENSIVE";
    StudyPlanTargetEnum["TARGET_REGULAR"] = "TARGET_REGULAR";
    return StudyPlanTargetEnum;
}({});
var graphql_schema_UserB2BStatusEnum = /*#__PURE__*/ function(UserB2BStatusEnum) {
    UserB2BStatusEnum["ACTIVE"] = "ACTIVE";
    UserB2BStatusEnum["DELETE"] = "DELETE";
    UserB2BStatusEnum["INACTIVE"] = "INACTIVE";
    UserB2BStatusEnum["PENDING"] = "PENDING";
    return UserB2BStatusEnum;
}({});
var graphql_schema_UserDegreeSegmentationEnum = /*#__PURE__*/ function(UserDegreeSegmentationEnum) {
    UserDegreeSegmentationEnum["ACTIVATED_DEGREE_SEGMENTATION"] = "ACTIVATED_DEGREE_SEGMENTATION";
    UserDegreeSegmentationEnum["EXPIRED_DEGREE_SEGMENTATION"] = "EXPIRED_DEGREE_SEGMENTATION";
    return UserDegreeSegmentationEnum;
}({});
var graphql_schema_UserTagEnum = /*#__PURE__*/ function(UserTagEnum) {
    UserTagEnum["B2B"] = "B2B";
    UserTagEnum["COLLEGE_SCHOLARSHIP"] = "COLLEGE_SCHOLARSHIP";
    UserTagEnum["MENTOR"] = "MENTOR";
    UserTagEnum["MENTOR_STAR"] = "MENTOR_STAR";
    UserTagEnum["PLUS"] = "PLUS";
    UserTagEnum["PREMIUM"] = "PREMIUM";
    UserTagEnum["PREMIUM_LITE"] = "PREMIUM_LITE";
    UserTagEnum["PREMIUM_STUDENT"] = "PREMIUM_STUDENT";
    UserTagEnum["PROFESSIONAL"] = "PROFESSIONAL";
    UserTagEnum["PROFESSOR"] = "PROFESSOR";
    UserTagEnum["SCHOLARSHIP"] = "SCHOLARSHIP";
    UserTagEnum["STAFF"] = "STAFF";
    return UserTagEnum;
}({});
export { graphql_schema_ApprovalRequirementEnum as ApprovalRequirementEnum, graphql_schema_BannerIdentifier as BannerIdentifier, graphql_schema_BannerLandingEnum as BannerLandingEnum, graphql_schema_CanAnswerReason as CanAnswerReason, graphql_schema_CertificateTypeEnum as CertificateTypeEnum, graphql_schema_ContactSourceEnum as ContactSourceEnum, graphql_schema_CourseTypeEnum as CourseTypeEnum, graphql_schema_CourseVideoTrailerSourceVideoSourceType as CourseVideoTrailerSourceVideoSourceType, graphql_schema_DegreeLearningCourseDetailProjectTypeEnum as DegreeLearningCourseDetailProjectTypeEnum, graphql_schema_DegreeLearningEventScheduleTargetEnum as DegreeLearningEventScheduleTargetEnum, graphql_schema_DegreeSyllabusStatusEnum as DegreeSyllabusStatusEnum, graphql_schema_EnrollmentTypeEnum as EnrollmentTypeEnum, graphql_schema_LiveTargetEnum as LiveTargetEnum, graphql_schema_MembershipTypeMethod as MembershipTypeMethod, graphql_schema_MembershipTypeTag as MembershipTypeTag, graphql_schema_MyUserTypeDocument as MyUserTypeDocument, graphql_schema_OnboardingEnum as OnboardingEnum, graphql_schema_ParticipationCertificateTypeEnum as ParticipationCertificateTypeEnum, graphql_schema_PopupType as PopupType, graphql_schema_ProjectStatus as ProjectStatus, graphql_schema_ProjectUploadValidationEnum as ProjectUploadValidationEnum, graphql_schema_PusherTargetEnum as PusherTargetEnum, graphql_schema_QuestionTypeEnumField as QuestionTypeEnumField, graphql_schema_SendDiscussionValidationEnum as SendDiscussionValidationEnum, graphql_schema_SourceEnum as SourceEnum, graphql_schema_SourcesEnum as SourcesEnum, graphql_schema_StatusProjectEnum as StatusProjectEnum, graphql_schema_StudyPlanFrequencyEnum as StudyPlanFrequencyEnum, graphql_schema_StudyPlanTargetEnum as StudyPlanTargetEnum, graphql_schema_UserB2BStatusEnum as UserB2BStatusEnum, graphql_schema_UserDegreeSegmentationEnum as UserDegreeSegmentationEnum, graphql_schema_UserTagEnum as UserTagEnum };
